//凯泉定制界面路由
export default [
  // 上海凯泉行业列表
  {
    path: "/:lang/Corp/SHKQ/EBook/ApplicationHangYeMain",
    name: "ApplicationHangYeMainBySHKQ",
    alias: [
      "/:lang/Corp/SHKQ/EBook/ApplicationHangYeMain",
      "/:lang/Corp/SHKQ/EBook/ApplicationHangYeMain",
      "/:lang/Corp/SHKQ/EBook/ApplicationHangYeMain",
      "/:lang/Corp/SHKQ/EBook/ApplicationHangYeMain",
      "/:lang/Corp/SHKQ/EBook/ApplicationHangYeMain",
    ],
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () =>
      import("/@/views/Corp/SHKQ/EBook/ApplicationHangYeMain.vue"),
  },
  // 上海凯泉系列列表（按行业）
  {
    path: "/:lang/Corp/SHKQ/EBook/SeriesListHY",
    name: "SeriesListHYBySHKQ",
    alias: [
      "/:lang/Corp/SHKQ/EBook/SeriesListHY",
      "/:lang/Corp/SHKQ/EBook/SeriesListHY",
      "/:lang/Corp/SHKQ/EBook/SeriesListHY",
      "/:lang/Corp/SHKQ/EBook/SeriesListHY",
      "/:lang/Corp/SHKQ/EBook/SeriesListHY",
    ],
    meta: {
      title: "",
      cache: false,
      modulsName: "ebook",
      noFrame: false,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/Corp/SHKQ/EBook/SeriesListHY.vue"),
  },
];
